import React from 'react';
import { render } from '@testing-library/react';
import { Tab } from './Tab';
import { TabGroup } from '../TabGroup';

describe('Tab', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<TabGroup
				dark={false}
				divider
				fitted={false}
				verticallyDivided={false}
				size="normal"
				type="underline"
				textAlign="center"
				data-auto-sel="automation-selector"
			>
				<Tab>First</Tab>
				<Tab>Second Tab</Tab>
				<Tab>Third Tab</Tab>
				<Tab>Fourth Tab</Tab>
			</TabGroup>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
